export default __webpack_public_path__ + "19f180955273ca638f52c5c0d5b2ab45.png";